import api from "./api";
import { User, LoginFormData, ApiResponse } from "../types";

interface LoginResponse {
  user: User;
  token: string;
}

export const authService = {
  async login(credentials: LoginFormData): Promise<LoginResponse> {
    const response = await api.post<ApiResponse<LoginResponse>>(
      "/auth/login",
      credentials
    );

    if (!response.data.success || !response.data.data) {
      throw new Error(response.data.message || "Login failed");
    }

    return response.data.data;
  },

  async verifyToken(token: string): Promise<User> {
    const response = await api.get<ApiResponse<{ user: User }>>(
      "/auth/verify",
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.data.success || !response.data.data) {
      throw new Error(response.data.message || "Token verification failed");
    }

    return response.data.data.user;
  },

  async register(credentials: LoginFormData): Promise<LoginResponse> {
    const response = await api.post<ApiResponse<LoginResponse>>(
      "/auth/register",
      credentials
    );

    if (!response.data.success || !response.data.data) {
      throw new Error(response.data.message || "Registration failed");
    }

    return response.data.data;
  },
};
